import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client'
import { GRAPHQL_INTERNAL_URL, GRAPHQL_URL } from '../../constants'
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries'
import { sha256 } from 'crypto-hash'

let graphqlClient = null
let persistedGraphqlClient = null

function getServerClient() {
  if (graphqlClient) return graphqlClient
  else {
    console.log('Creating new client')
    graphqlClient = new ApolloClient({
      ssrMode: typeof window === 'undefined',
      uri: typeof window === 'undefined' ? GRAPHQL_INTERNAL_URL : GRAPHQL_URL,
      cache: new InMemoryCache({ addTypename: false, resultCaching: false })
    })
    return graphqlClient
  }
}

function getPersistedClient() {
  if (persistedGraphqlClient) return persistedGraphqlClient

  const linkChain = createPersistedQueryLink({
    sha256,
    useGETForHashedQueries: true
  }).concat(new HttpLink({ uri: GRAPHQL_URL }))

  persistedGraphqlClient = new ApolloClient({
    ssrMode: typeof window === 'undefined',
    link: linkChain,
    cache: new InMemoryCache()
  })
  console.log('Creating new persisted client')
  return persistedGraphqlClient
}

// const graphqlClient = new ApolloClient({
//   ssrMode: typeof window === 'undefined',
//   uri: typeof window === 'undefined' ? GRAPHQL_INTERNAL_URL : GRAPHQL_URL,
//   cache: new InMemoryCache()
// })

export default async function queryGraphql(query, variables = {}, token, fetchPolicy, usePersisted) {
  const client = usePersisted ? getPersistedClient() : getServerClient()
  try {
    const d = await client.query({
      query,
      variables,
      // fetchPolicy: fetchPolicy || 'cache-first',
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
      context: { platform: 'web', headers: { Authorization: token || '' } }
    })
    // console.log(d)
    return d
  } catch (error) {
    console.log({
      msg: error?.message,
      name: query?.definitions?.[0]?.name?.value,
      status: error?.networkError?.statusCode || error?.networkError?.result,
      variables
    })
    // Preserve original error structure
    const graphQLError = new Error()

    // Copy all properties from original error
    Object.assign(graphQLError, error)

    // Add additional useful properties
    graphQLError.message = error?.message || 'GraphQL query failed'
    graphQLError.data = error?.networkError?.result || error?.graphQLErrors?.[0]?.extensions
    graphQLError.status = error?.networkError?.statusCode || 500
    graphQLError.queryName = query?.definitions?.[0]?.name?.value
    graphQLError.variables = variables

    // Preserve original stack trace
    graphQLError.stack = error.stack
    throw graphQLError
  }
  // return client.query({
  //   query,
  //   variables,
  //   // fetchPolicy: fetchPolicy || 'cache-first',
  //   fetchPolicy: 'no-cache',
  //   errorPolicy: 'ignore',
  //   context: { platform: 'web', headers: { Authorization: token || '' } }
  // })
}
